class ClothingShippingReturns extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.dialog = this.querySelector('dialog');
    this.tabs = [...this.querySelectorAll('[data-shipping-tab]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    if (!this.dialog || !this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.controller = new AbortController();
    const options = { signal: this.controller.signal };

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-shipping-details]');
      if (trigger && typeof this.dialog.showModal === 'function') {
        event.preventDefault();
        this.trigger = trigger;
        this.selectTab(0);
        if (!this.dialog.open) this.dialog.showModal();
        this.syncScrollLock();
        this.tabs[0]?.focus();
        return;
      }

      const tab = event.target.closest('[data-shipping-tab]');
      if (tab) this.selectTab(this.tabs.indexOf(tab));
      if (event.target.closest('[data-shipping-close]')) this.dialog.close();

      if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.dialog.close();
        }
      }
    }, options);

    this.addEventListener('keydown', (event) => {
      const index = this.tabs.indexOf(event.target);
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      this.selectTab(next);
      this.tabs[next].focus();
    }, options);

    this.dialog.addEventListener('close', () => {
      this.syncScrollLock();
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }, options);
  }

  disconnectedCallback() {
    if (this.dialog?.open) this.dialog.close();
    this.controller?.abort();
    this.syncScrollLock();
  }

  selectTab(index) {
    if (!this.tabs[index]) return;
    this.dialog.scrollTop = 0;
    this.tabs.forEach((tab, position) => {
      const selected = position === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      this.panels[position].hidden = !selected;
    });
    const heading = this.panels[index].querySelector('h2');
    if (heading) this.dialog.setAttribute('aria-labelledby', heading.id);
  }

  syncScrollLock() {
    document.body.classList.toggle('clothing-shipping-returns-open', Boolean(document.querySelector('.clothing-shipping-returns__dialog[open]')));
  }
}

if (!customElements.get('clothing-shipping-returns')) {
  customElements.define('clothing-shipping-returns', ClothingShippingReturns);
}
